// var postUrl = "https://test.sanctuarytech.co/manager"; // 测试环境
// var postUrl = 'https://uat.sanctuarytech.co/manager'; //uat环境
var postUrl = "https://m.vip.jjlin.tech/manager"; //生产环境
// var postUrl = 'http://47.241.73.138/manager';//生产环境子后管
// var lottery = "https://test.sanctuarytech.co/lottery?type="; //抽奖链接测试，
var lottery = "https://jjlin.com/lottery?type="; //抽奖链接生产，
// var postUrl = "/api"; //生产环境子后管
export default {
  mainColor: "#603D8E",
  mainDarkerColor: "#482675",
  imagespostUrl: postUrl + "/request/apply/image",
  videopostUrl: postUrl + "/article/video",
  excelpostUrl: postUrl + "/request/apply/uploadExcle",
  orderExcelPostUrl: postUrl + "/request/order/uploadExcle",
  allorderExcelPostUrl: postUrl + "/request/after/sales/batch/delivery",
  blackExcelPostUrl: postUrl + "/request/blackMember/uploadExcel",
  productsPostUrl: postUrl + "/request/mall/upload/goods/vip",
  orderPostUrl: postUrl + "/request/mall/upload/this/year/vip",
  activityPostUrl: postUrl + "/request/apply/upload/excel",
  activityPostResultUrl: postUrl + "/request/apply/upload/excel/result",
  qrcodePostUrl: postUrl + "/write/off/activity/upload/list",
  managerPostUrl: postUrl + "/write/off/activity/manager/excel",
  yunfeiUrl: postUrl + "/request/freight/upload",
  queationExcelUrl: postUrl + "/request/question/excel",
  lotteryPostUrl: lottery,
  jsonConfig: { "Content-Type": "application/json" },
  postUrl: postUrl,
  picFileUrl: "https://start.sanctuarytech.co/",
  xwPic:
    "?x-oss-process=image/format,jpg,image/watermark,image_bG9nLnBuZz94LW9zcy1wcm9jZXNzPWltYWdlL3Jlc2l6ZSxQXzIw,t_90,g_se,x_10,y_10"
};



// WEBPACK FOOTER //
// ./src/utils/global.js